import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';

import type { EPPhoneCellProps } from './EscalationProfile.types';

const EPPhoneCell = ({ user }: EPPhoneCellProps) => {
  if (!user.phone_number && !user.office_phone_number) {
    return (
      <Stack
        direction="row"
        spacing={0.5}
        style={{
          color: 'var(--mui-palette-warning-main)',
          alignItems: 'center'
        }}
      >
        <FontAwesomeIcon icon={faTriangleExclamation} />
        <Typography>No phone</Typography>
      </Stack>
    );
  }
  return (
    <Stack direction="column" spacing={0.25}>
      {user.phone_number && (
        <Stack
          sx={{ flexDirection: 'row', alignItems: 'center' }}
          spacing={0.5}
        >
          <Typography>{user.phone_number}</Typography>
          <Typography variant="caption" color="text.secondary">
            Mobile
          </Typography>
          {user.phone_extension && (
            <Typography variant="caption" color="text.secondary">
              · post-connect: {user.phone_extension}
            </Typography>
          )}
        </Stack>
      )}
      {user.office_phone_number && (
        <Stack
          sx={{ flexDirection: 'row', alignItems: 'center' }}
          spacing={0.5}
        >
          <Typography>{user.office_phone_number}</Typography>
          <Typography variant="caption" color="text.secondary">
            Office
          </Typography>
          {user.office_phone_extension && (
            <Typography variant="caption" color="text.secondary">
              · post-connect: {user.office_phone_extension}
            </Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default EPPhoneCell;
